// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"195":"1170c92d","317":"9f68042f","451":"7677d934","470":"0d279ed0","664":"a440c7b7"}[chunkId] + ".css";
};